import React from "react";
import Layout from "../common/Layout";

const Forms: React.FC = () => {
  return <Layout title="Lomakkeet">
  </Layout>;
};

export default Forms;
